const googleMapEvents: StandardObjectInterface = {
    initializeMap: 'initialize-map',
    newAddressCoordinates: 'new-address-coordinates'
};

export default googleMapEvents;
